import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d978519c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title pt-4" }, "Marques par catégorie URSSAF", -1))

import CustomButton from "@/components/forms/CustomButton.vue";
import PageMappingCategoryUrssafBrandList from "@/components/category/urssaf/PageMappingCategoryUrssafBrandList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageMappingCategoryUrssafBrandListDetail',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: {
            name: 'ListUrssaf'
        },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createVNode(PageMappingCategoryUrssafBrandList)
  ], 64))
}
}

})